<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="ip_primario" class="col-sm-2 control-label">TEMPO PARADO (seg):</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.timer_ignition_off" class="form-control input-sm" id="ip_primario">
            </div>
            <label for="porta_primario" class="col-sm-2 control-label">TEMPO DIRIGINDO (seg):</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.timer_ignition_on"  class="form-control" id="porta_primario" >
            </div>
        </div>
        <div class="form-group">
            <label for="ip_secundario" class="col-sm-2 control-label">TEMPO EM EMERGÊNCIA:</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.timer_panic" class="form-control" id="ip_secundario">
            </div>
            <label for="porta_secundario" class="col-sm-2 control-label">TEMPO PARA SLEEP:</label>
            <div class="col-sm-2">
                <input type="number" v-model.number="config.timer2sleep"  class="form-control" id="porta_secundario" >
            </div>
        </div>
        <div class="form-group">
            <label for="apn" class="col-sm-2 control-label">KEEP ALIVE</label>
            <div class="col-sm-3">
                <input type="number" v-model.number="config.ack_timeout"  class="form-control" id="apn" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Bus} from '../../../../class/bus';
    import {Maxtrack} from '../../../../class/maxtrack';

    export default {
        name: "TemposMaxtrack",
        props: {
            config: {
                default: null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Maxtrack.sendTempos(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
